const langSwitcher = document.getElementById('language-toggle');
const languagesList = document.getElementById('languages-list');

if (langSwitcher) {
    langSwitcher.addEventListener('click', function () {
        languagesList.classList.toggle('open');
    });

    langSwitcher.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            // Toggle dropdown on Enter key
            event.preventDefault();
            languagesList.classList.toggle('open');
        }
    });
}
document.addEventListener('DOMContentLoaded', () => {
    // NiceSelect.bind(languagesList);
});